// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jQyK","question":"styles_question__3o4Af","description":"styles_description__23riv"};